import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1200Model } from '../kymw1200.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * WK実績履歴情報作成サービス
 * @export RegistWkResultListService
 * @class RegistWkResultListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistWkResultListService extends PlessJsonResponderSub<null> {
  model: KYMW1200Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistWkResultListService
   */
  private getBody(): PlessRequest {
    const param = {
      MediumType: this.model.mediumType,
      BuyerCodes: this.model.getRequestBuyerCodes(),
      StartOrderCode: this.model.orderCodeFrom,
      EndOrderCode: this.model.orderCodeTo,
      SupplierCode: this.model.isSupplier ? this.model.userSupplierCode : null,
      StartCatalogId: this.model.catalogIdFrom ?? this.model.orderCodeList.find(_ => _.OrderCode === this.model.orderCodeFrom).CatalogID,
      EndCatalogId: this.model.catalogIdTo ?? this.model.orderCodeList.find(_ => _.OrderCode === this.model.orderCodeTo).CatalogID,
      PrevFlg: this.model.isBuyer || this.model.isLeader || this.model.isPast ? '1' :  '0',
    };
    if (!param.SupplierCode) delete param.SupplierCode;

    return new PlessRequest({
      parameter: param,
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param f
   * @memberof RegistWkResultListService
   */
  execute(model: KYMW1200Model, f: () => void = null): void {
    this.model = model;
    this.calbak = f;
    this.send('registWkResultList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof RegistWkResultListService
   */
  success() {
    if (this.calbak) this.calbak();
  }
}
